var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-wysiwyg"},[_c('ckeditor',{attrs:{"config":_vm.options,"readOnly":_vm.disabled},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }